import React, { FC } from 'react';
import { ParticipantActivitySummary } from './types';

interface ActivitySummaryProps {
  data?: ParticipantActivitySummary | null;
}

const ActivitySummary: FC<ActivitySummaryProps> = ({ data }) => {
  if (!data) return null;

  const total = data.active + data.yesterday + data.last_week + data.inactive;

  const items = [
    { label: 'Active today',    value: data.active,     color: '#059669', bg: '#dcfce7' },
    { label: 'Active yesterday',value: data.yesterday,  color: '#0891b2', bg: '#e0f2fe' },
    { label: 'Last 7 days',     value: data.last_week,  color: '#d97706', bg: '#fef9c3' },
    { label: 'No activity',     value: data.inactive,   color: '#94a3b8', bg: '#f1f5f9' },
  ];

  return (
    <div className="bg-white rounded-3 shadow-sm p-4 h-100" style={{ border: '1px solid #f0f0f0' }}>
      <h6 className="fw-bold mb-4" style={{ color: '#1a1a2e', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        Participant Activity
      </h6>
      <div className="d-flex flex-column gap-3">
        {items.map(item => {
          const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
          return (
            <div key={item.label}>
              <div className="d-flex align-items-center justify-content-between mb-1">
                <span style={{ fontSize: 12, color: '#475569' }}>{item.label}</span>
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill fw-bold"
                    style={{ fontSize: 11, padding: '3px 8px', background: item.bg, color: item.color }}
                  >
                    {item.value}
                  </span>
                  <span className="text-muted" style={{ fontSize: 11, width: 28, textAlign: 'right' }}>{pct}%</span>
                </div>
              </div>
              <div className="rounded-pill overflow-hidden" style={{ height: 4, background: '#f1f5f9' }}>
                <div style={{ height: '100%', width: `${pct}%`, background: item.color, borderRadius: 4, transition: 'width 0.5s' }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivitySummary;
